import { WorkingDocumentModel } from "models/WorkingDocumentModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

export interface DocumentsContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: WorkingDocumentModel) => void;
}

export const DocumentsContextMenuContext = createContext({} as DocumentsContextMenuContextProps);
